import * as React from "react";
const SvgAudioPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.16233 3.04657L11.9371 7.5L4.16233 11.9534L4.16233 3.04657Z", fill: "none", strokeWidth: 1.3 }));
export default SvgAudioPlay;
